import { themeColors } from '@/theme/colors';
import { Icon } from '@lego/connect-components-react';
import type { ReactNode } from 'react';

type OnboardingResourceItemProps = {
  children: ReactNode;
  icon: 'location-dot' | 'book-open' | 'hand';
  title: string;
};

// TODO(connect-ds): Replace native layout when Connect provides an equivalent stack component.
export const OnboardingResourceItem = ({
  children,
  icon,
  title,
}: OnboardingResourceItemProps) => (
  <div
    style={{
      alignItems: 'flex-start',
      display: 'flex',
      flex: 1,
      gap: '16px',
      minWidth: 0,
    }}
  >
    <div
      style={{
        alignItems: 'center',
        backgroundColor: themeColors.interactive.primary.subtle.hovered,
        borderRadius: '8px',
        display: 'flex',
        flexShrink: 0,
        height: '40px',
        justifyContent: 'center',
        width: '40px',
      }}
    >
      <Icon
        aria-label={`${title} icon`}
        name={icon}
        size="medium"
        color="ds-color-interactive-primary-enabled"
      />
    </div>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        minWidth: 0,
      }}
    >
      <span
        style={{
          fontFamily: 'var(--ds-font-font-family)',
          fontSize: 'var(--ds-screen-text-font-size-heading-sm)',
          fontWeight: 'var(--ds-screen-text-font-weight-bold)',
          lineHeight: 'var(--ds-screen-text-line-height-heading-sm)',
          margin: 0,
        }}
      >
        {title}
      </span>
      <div
        style={{
          alignItems: 'flex-start',
          color: 'var(--ds-color-content-subtle)',
          display: 'flex',
          flexDirection: 'column',
          fontFamily: 'var(--ds-font-font-family)',
          fontSize: 'var(--ds-screen-text-font-size-body-sm)',
          lineHeight: 'var(--ds-screen-text-line-height-body-sm)',
        }}
      >
        {children}
      </div>
    </div>
  </div>
);
